





























import { Component, Vue } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';

import RiskResourcesService from '@/services/RiskResources';

import Welcome from '@/components/RiskResources/Welcome.vue';
import Sidebar from '@/components/RiskResources/Sidebar/Menu.vue';
import Accordion from '@/components/RiskResources/Accordion.vue';

@Component({
	name: 'SidebarAndContent',
	components: {
		Welcome,
		Sidebar,
		Accordion,
	},
})
export default class SidebarAndContent extends Vue {
	@Getter('pageContent', { namespace: 'RiskResources' }) private pageContent: any;
	@Getter('pageTitle', { namespace: 'RiskResources' }) private pageTitle: any;

	private RiskResourcesService: typeof RiskResourcesService = RiskResourcesService;
}
